// api client
import { client } from '../api/client'

// types
import { ScheduleData } from '../types/scheduleTypes'

/**
 * Schedule get data
 *
 * @returns Promise<ScheduleData>
 */
const fetchData = (id: number): Promise<ScheduleData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(`/OnBoarding/${id}/Schedule`)

      if (response.status === 200) {
        const scheduleData: ScheduleData = {
          essUserOnBoardingKey: response.data.essUserOnBoardingKey,
          brandingName: response.data.brandingName,
          storeName: response.data.storeName,
          storeShortName: response.data.storeShortName,
          storeAddress1: response.data.storeAddress1,
          storeAddress2: response.data.storeAddress2,
          storeAddress3: response.data.storeAddress3,
          mondayHours: response.data.mondayHours,
          tuesdayHours: response.data.tuesdayHours,
          wednesdayHours: response.data.wednesdayHours,
          thursdayHours: response.data.thursdayHours,
          fridayHours: response.data.fridayHours,
          saturdayHours: response.data.saturdayHours,
          sundayHours: response.data.sundayHours,
          requestedHours: response.data.requestedHours,
          mondayScheduleValue: response.data.mondayScheduleValue,
          mondayScheduleNAComment: response.data.mondayScheduleNAComment,
          mondayScheduleTime1Start: response.data.mondayScheduleTime1Start,
          mondayScheduleTime1End: response.data.mondayScheduleTime1End,
          mondayScheduleTime2Start: response.data.mondayScheduleTime2Start,
          mondayScheduleTime2End: response.data.mondayScheduleTime2End,
          tuesdayScheduleValue: response.data.tuesdayScheduleValue,
          tuesdayScheduleNAComment: response.data.tuesdayScheduleNAComment,
          tuesdayScheduleTime1Start: response.data.tuesdayScheduleTime1Start,
          tuesdayScheduleTime1End: response.data.tuesdayScheduleTime1End,
          tuesdayScheduleTime2Start: response.data.tuesdayScheduleTime2Start,
          tuesdayScheduleTime2End: response.data.tuesdayScheduleTime2End,
          wednesdayScheduleValue: response.data.wednesdayScheduleValue,
          wednesdayScheduleNAComment: response.data.wednesdayScheduleNAComment,
          wednesdayScheduleTime1Start:
            response.data.wednesdayScheduleTime1Start,
          wednesdayScheduleTime1End: response.data.wednesdayScheduleTime1End,
          wednesdayScheduleTime2Start:
            response.data.wednesdayScheduleTime2Start,
          wednesdayScheduleTime2End: response.data.wednesdayScheduleTime2End,
          thursdayScheduleValue: response.data.thursdayScheduleValue,
          thursdayScheduleNAComment: response.data.thursdayScheduleNAComment,
          thursdayScheduleTime1Start: response.data.thursdayScheduleTime1Start,
          thursdayScheduleTime1End: response.data.thursdayScheduleTime1End,
          thursdayScheduleTime2Start: response.data.thursdayScheduleTime2Start,
          thursdayScheduleTime2End: response.data.thursdayScheduleTime2End,
          fridayScheduleValue: response.data.fridayScheduleValue,
          fridayScheduleNAComment: response.data.fridayScheduleNAComment,
          fridayScheduleTime1Start: response.data.fridayScheduleTime1Start,
          fridayScheduleTime1End: response.data.fridayScheduleTime1End,
          fridayScheduleTime2Start: response.data.fridayScheduleTime2Start,
          fridayScheduleTime2End: response.data.fridayScheduleTime2End,
          saturdayScheduleValue: response.data.saturdayScheduleValue,
          saturdayScheduleNAComment: response.data.saturdayScheduleNAComment,
          saturdayScheduleTime1Start: response.data.saturdayScheduleTime1Start,
          saturdayScheduleTime1End: response.data.saturdayScheduleTime1End,
          saturdayScheduleTime2Start: response.data.saturdayScheduleTime2Start,
          saturdayScheduleTime2End: response.data.saturdayScheduleTime2End,
          sundayScheduleValue: response.data.sundayScheduleValue,
          sundayScheduleNAComment: response.data.sundayScheduleNAComment,
          sundayScheduleTime1Start: response.data.sundayScheduleTime1Start,
          sundayScheduleTime1End: response.data.sundayScheduleTime1End,
          sundayScheduleTime2Start: response.data.sundayScheduleTime2Start,
          sundayScheduleTime2End: response.data.sundayScheduleTime2End,
          schedulingComment: response.data.schedulingComment,
          scheduleStatusValue: response.data.scheduleStatusValue,
          statusDescription: response.data.statusDescription
        }

        resolve(scheduleData)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Schedule update data
 *
 * @returns Promise<ScheduleData>
 */
const updateData = (id: number, data: ScheduleData): Promise<ScheduleData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(`/OnBoarding/${id}/Schedule`, data)

     
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}

export const scheduleService = { fetchData, updateData }
